import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef, useState } from 'react';
import Card from '@uiw/react-card';
import Icon from '@uiw/react-icon';
import Input from '@uiw/react-input';
import TreeChecked from '@uiw/react-tree-checked';
import "./style/index.css";
import Checkbox from '@uiw/react-checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CheckedStatus = /*#__PURE__*/function (CheckedStatus) {
  CheckedStatus[CheckedStatus["UnChecked"] = 0] = "UnChecked";
  CheckedStatus[CheckedStatus["AllChecked"] = 1] = "AllChecked";
  CheckedStatus[CheckedStatus["Indeterminate"] = 2] = "Indeterminate";
  return CheckedStatus;
}(CheckedStatus || {});
function Transfer(props) {
  var {
    placeholder,
    options,
    value = [],
    showSearch = false,
    selectedAll = false,
    bodyStyle,
    style,
    className,
    prefixCls = 'w-transfer'
  } = props;
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  var [searchValueLeft, searchValueLeftSet] = useState('');
  var [searchValueRight, searchValueRightSet] = useState('');
  var [selectedOptions, selectedOptionSet] = useState(options || []);
  var selectedOptionsShowCount = useRef(0);
  var [selectOption, selectOptionSet] = useState(new Map());
  var [leftSelectOption, leftSelectOptionSet] = useState(new Map());
  var [leftSelectedKeys, leftSelectedKeySet] = useState([]);
  var [rightSelectedKeys, rightSelectedKeySet] = useState([]);
  var [rightOpions, rightOpionSet] = useState([]);
  var [selectAllChecked, selectAllCheckedSet] = useState({
    left: CheckedStatus.UnChecked,
    right: CheckedStatus.UnChecked
  });
  useEffect(() => {
    if (value) {
      rightOpionSet(value || []);
      value == null || value.forEach(selectd => selectOption.set(selectd.key, selectd.label));
      hiddenNode(child => !!(value != null && value.find(selectd => child.key === selectd.key)));
    }
  }, [JSON.stringify(value)]);
  var hiddenNode = callBackfn => {
    selectedOptionsShowCount.current = 0;
    var hiddenNodeForSeach = childrens => {
      childrens.forEach(child => {
        var _child$children;
        var isHide = callBackfn(child); // && parentIsHide;
        if (!!((_child$children = child.children) != null && _child$children.length)) {
          hiddenNodeForSeach(child.children);
          var find = child.children.find(item => !item.hideNode);
          child.hideNode = isHide && !find;
        } else {
          child.hideNode = isHide;
        }
        if (!child.hideNode) {
          selectedOptionsShowCount.current++;
        }
      });
    };
    hiddenNodeForSeach(selectedOptions);
    selectedOptionSet([...selectedOptions]);
  };
  var getOptionsRecursion = (childrens, selectOption, isAdd) => {
    var addOrDel = (key, label, isAdd) => {
      if (isAdd) {
        selectOption.set(key, label);
      } else {
        selectOption.delete(key);
      }
    };
    var iteratorParent = child => {
      if (child.parent) {
        var selectCount = child.parent.children.filter(child => !selectOption.get(child.key) && !child.hideNode).length;
        addOrDel(child.parent.key, child.parent.label, selectCount === 0);
        iteratorParent(child.parent);
      }
    };
    childrens.forEach(child => {
      var _child$children2, _child$label;
      if (!!((_child$children2 = child.children) != null && _child$children2.length)) {
        selectOption = getOptionsRecursion(child.children, selectOption, isAdd);
      }
      addOrDel(child.key, (_child$label = child.label) == null ? void 0 : _child$label.toString(), isAdd);
      iteratorParent(child);
    });
    return selectOption;
  };
  var leftTreeOnSelected = (selectedKeys, _1, isChecked, evn) => {
    leftSelectedKeySet(selectedKeys);
    var selectOptionTemp = getOptionsRecursion([evn], leftSelectOption, isChecked);
    leftSelectOptionSet(selectOptionTemp);
  };
  var rightTreeOnSelected = selectedKeys => {
    rightSelectedKeySet(selectedKeys);
  };
  var transferClick = transferType => {
    if (transferType === 'left') {
      leftSelectOption.forEach((value, key) => {
        selectOption.set(key, value);
      });
      leftSelectOptionSet(new Map());
      leftSelectedKeySet([]);
    } else {
      rightSelectedKeys.forEach(key => {
        selectOption.delete(key);
      });
      rightSelectedKeySet([]);
    }
    selectOptionSet(selectOption);
    var option = [];
    selectOption.forEach((label, key) => option.push({
      key,
      label
    }));
    props.onChange == null || props.onChange(transferType, option);
  };
  var searchValueLeftChange = searchValue => {
    hiddenNode(child => {
      var searchIsMatch = !child.label.includes(searchValue.trim());
      if (!searchIsMatch) {
        var isSekected = rightOpions.find(selected => selected.key === child.key);
        searchIsMatch = !!isSekected;
      }
      return searchIsMatch;
    });
    searchValueLeftSet(searchValue);
    props.onSearch == null || props.onSearch('left', searchValue);
  };
  var searchValueRightChange = searchValue => {
    searchValueRightSet(searchValue);
    rightOpions.forEach(option => {
      var isHide = !option.label.includes(searchValue.trim());
      option.hideNode = isHide;
    });
    rightOpionSet(rightOpions);
    props.onSearch == null || props.onSearch('right', searchValue);
  };
  var selectAllLeftChange = e => {
    var isChecked = e.target.checked;
    selectAllChecked.left = isChecked ? 1 : 0;
    if (isChecked) {
      var keys = [];
      var selectedOptionsRecursion = selectedOptions => {
        selectedOptions.forEach(child => {
          var _child$children3;
          if ((_child$children3 = child.children) != null && _child$children3.length) {
            selectedOptionsRecursion(child.children);
          }
          if (!child.hideNode) {
            leftSelectOption.set(child.key, child.label);
            keys.push(child.key);
          }
        });
      };
      selectedOptionsRecursion(selectedOptions);
      leftSelectOptionSet(leftSelectOption);
      leftSelectedKeySet(keys);
    } else {
      leftSelectedKeySet([]);
      leftSelectOptionSet(new Map());
    }
    selectAllCheckedSet(selectAllChecked);
  };
  var selectAllRightChange = e => {
    var isChecked = e.target.checked;
    selectAllChecked.right = isChecked ? 1 : 0;
    if (isChecked) {
      var keys = rightOpions.map(child => child.key);
      rightSelectedKeySet(keys);
    } else {
      rightSelectedKeySet([]);
    }
    selectAllCheckedSet(selectAllChecked);
  };
  var Arrow = props => /*#__PURE__*/_jsx(Icon, {
    onClick: () => props.click(),
    type: "down-square-o",
    className: prefixCls + "-arrow",
    style: _extends({
      fontSize: 20,
      stroke: '#e9e9e9',
      fill: '#333'
    }, props.style)
  });
  return /*#__PURE__*/_jsxs("div", {
    className: cls,
    style: _extends({
      width: 400
    }, style),
    children: [/*#__PURE__*/_jsxs(Card, {
      bodyStyle: {
        padding: '5px 9px'
      },
      title: /*#__PURE__*/_jsxs("div", {
        children: [selectedAll && /*#__PURE__*/_jsx(Checkbox, {
          indeterminate: leftSelectedKeys.length < selectedOptionsShowCount.current && !!leftSelectedKeys.length,
          checked: leftSelectedKeys.length >= selectedOptionsShowCount.current && !!leftSelectedKeys.length,
          onChange: selectAllLeftChange
        }), /*#__PURE__*/_jsxs("label", {
          style: {
            marginLeft: 3
          },
          children: [leftSelectedKeys.length, "/", selectedOptionsShowCount.current]
        })]
      }),
      className: prefixCls + "-card",
      children: [showSearch && /*#__PURE__*/_jsx(Input, {
        placeholder: placeholder,
        value: searchValueLeft,
        onChange: e => searchValueLeftChange(e.target.value)
      }), /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-cheked-content",
        children: /*#__PURE__*/_jsx(TreeChecked, {
          defaultExpandAll: true,
          placeholder: placeholder || '搜索选项',
          data: selectedOptions,
          selectedKeys: leftSelectedKeys,
          onSelected: leftTreeOnSelected
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: prefixCls + "-arrow-content",
      children: [/*#__PURE__*/_jsx(Arrow, {
        click: () => transferClick('left'),
        style: {
          transform: 'rotate(-90deg)',
          background: leftSelectedKeys.length > 0 ? '#393E48' : 'none'
        }
      }), /*#__PURE__*/_jsx(Arrow, {
        click: () => transferClick('right'),
        style: {
          transform: 'rotate(90deg)',
          background: rightSelectedKeys.length > 0 ? '#393E48' : 'none'
        }
      })]
    }), /*#__PURE__*/_jsxs(Card, {
      bodyStyle: {
        padding: '5px 9px'
      },
      className: prefixCls + "-card",
      title: /*#__PURE__*/_jsxs("div", {
        children: [selectedAll && /*#__PURE__*/_jsx(Checkbox, {
          indeterminate: rightSelectedKeys.length < rightOpions.length && !!rightSelectedKeys.length,
          checked: rightSelectedKeys.length === rightOpions.length && !!rightSelectedKeys.length,
          onChange: selectAllRightChange
        }), /*#__PURE__*/_jsxs("label", {
          style: {
            marginLeft: 3
          },
          children: [rightSelectedKeys.length, "/", rightOpions.length]
        })]
      }),
      children: [showSearch && /*#__PURE__*/_jsx(Input, {
        placeholder: placeholder,
        value: searchValueRight,
        onChange: e => searchValueRightChange(e.target.value)
      }), /*#__PURE__*/_jsx("div", {
        className: prefixCls + "-cheked-content",
        style: bodyStyle,
        children: /*#__PURE__*/_jsx(TreeChecked, {
          data: rightOpions,
          selectedKeys: rightSelectedKeys,
          onSelected: rightTreeOnSelected
        })
      })]
    })]
  });
}
export default Transfer;